import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "28",
  viewBox: "0 0 40 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M35.6506 0.856638C37.3639 1.31792 38.7148 2.66882 39.1761 4.38216C40.0328 7.51229 39.9998 14.0362 39.9998 14.0362C39.9998 14.0362 39.9998 20.5271 39.1761 23.6572C38.7148 25.3705 37.3639 26.7214 35.6506 27.1827C32.5205 28.0064 19.9999 28.0064 19.9999 28.0064C19.9999 28.0064 7.51232 28.0064 4.34924 27.1498C2.6359 26.6885 1.285 25.3376 0.82372 23.6242C0 20.5271 0 14.0032 0 14.0032C0 14.0032 0 7.51229 0.82372 4.38216C1.285 2.66882 2.66885 1.28497 4.34924 0.823689C7.47937 -3.05176e-05 19.9999 -3.05176e-05 19.9999 -3.05176e-05C19.9999 -3.05176e-05 32.5205 -3.05176e-05 35.6506 0.856638ZM26.425 14.0031L16.0132 19.9998V8.00646L26.425 14.0031Z"
    }, null, -1)
  ])))
}
export default { render: render }